import React, { useEffect, useState } from 'react';
import styles from './CuadroColapsable.module.css';

/**
 * Componente genérico y reutilizable para mostrar contenido colapsable.
 *
 * Props:
 *   titulo           – string: texto del encabezado
 *   etiqueta         – string: nombre del cuadro (opcional)
 *   valorDestacado   – string: valor elegido a resaltar (opcional)
 *   expandidoPorDefecto – boolean: si debe expandirse por defecto (default: true)
 *   children         – ReactNode: contenido a mostrar dentro del cuadro
 *   puedeColapsar    – boolean: si el usuario puede colapsar/expandir (default: true)
 *   onExpandChange   – function(boolean): callback al cambiar expandido
 */
const CuadroColapsable = ({
  titulo,
  etiqueta,
  valorDestacado,
  expandidoPorDefecto = true,
  children,
  puedeColapsar = true,
  onExpandChange,
}) => {
  const [expandido, setExpandido] = useState(expandidoPorDefecto);

  useEffect(() => {
    setExpandido(expandidoPorDefecto);
  }, [expandidoPorDefecto]);

  const toggleExpandido = () => {
    if (puedeColapsar) {
      const siguiente = !expandido;
      setExpandido(siguiente);
      if (onExpandChange) {
        onExpandChange(siguiente);
      }
    }
  };

  return (
    <div className={styles.cuadro}>
      <div className={styles.encabezado}>
        <span className={styles.titulo}>
          {etiqueta ? (
            <>
              <span className={styles.etiqueta}>{etiqueta}</span>
              {valorDestacado && <span className={styles.valorDestacado}>{valorDestacado}</span>}
            </>
          ) : (
            titulo
          )}
        </span>
        {puedeColapsar && (
          <button
            className={styles.botonToggle}
            onClick={toggleExpandido}
            title={expandido ? 'Cerrar' : 'Abrir'}
            aria-expanded={expandido}
            aria-label={`${expandido ? 'Cerrar' : 'Abrir'} ${titulo}`}
          >
            {expandido ? '▲' : '▼'}
          </button>
        )}
      </div>
      {expandido && <div className={styles.contenido}>{children}</div>}
    </div>
  );
};

export default CuadroColapsable;
